import { Entity } from '../../../core/context/entity';

export class AssetRelationType extends Entity {
    constructor({ id, name }: { id: string; name?: string }) {
        super({ id, name });
    }
}
